if (!customElements.get('geosort-story-features')) {
  customElements.define('geosort-story-features', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      this.animations = new Map();
      const items = [...this.querySelectorAll('.gsf-feature')];
      items.forEach(item => {
        item.dataset.expanded = String(item.open);
        item.querySelector('summary').setAttribute('aria-expanded', String(item.open));
      });
      const click = event => {
        const summary = event.target.closest('summary');
        if (!summary || !this.contains(summary)) return;
        event.preventDefault();
        this.setExpanded(summary.parentElement, summary.parentElement.dataset.expanded !== 'true');
      };
      const select = event => {
        const item = event.target.closest('.gsf-feature');
        if (item && this.contains(item)) this.setExpanded(item, true);
      };
      this.addEventListener('click', click);
      this.addEventListener('shopify:block:select', select);
      this.cleanup = () => {
        this.removeEventListener('click', click);
        this.removeEventListener('shopify:block:select', select);
        this.animations.forEach(animation => animation.cancel());
      };
    }

    setExpanded(item, expanded) {
      const panel = item.querySelector('.gsf-panel');
      const from = item.open ? panel.getBoundingClientRect().height : 0;
      this.animations.get(item)?.cancel();
      item.open = true;
      item.dataset.expanded = String(expanded);
      item.querySelector('summary').setAttribute('aria-expanded', String(expanded));
      panel.inert = !expanded;
      panel.setAttribute('aria-hidden', String(!expanded));
      const finish = () => {
        item.open = expanded;
        this.animations.delete(item);
      };
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return finish();
      const animation = panel.animate(
        [{ height: `${from}px` }, { height: `${expanded ? panel.scrollHeight : 0}px` }],
        { duration: 380, easing: 'cubic-bezier(.22,1,.36,1)' }
      );
      this.animations.set(item, animation);
      animation.onfinish = finish;
    }

    disconnectedCallback() {
      this.cleanup?.();
      this.cleanup = null;
    }
  });
}
